import { createFileRoute } from '@tanstack/react-router';
import { NewOrganizationPage } from '@/features/organizer/pages/NewOrganizationPage';
import { myOrganizationsQuery } from '@/features/organizer/api';

export const Route = createFileRoute('/_authed/org/new')({
  staticData: { help: 'new-organization' },
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(myOrganizationsQuery());
  },
  component: NewOrganizationPage,
});
